export enum Links {
  Home = "/",
  Details = "/details",
  Email = "/email",
  ExistingRSVP = "/existing-rsvp",
  Update = "/update",
  Summary = "/summary",
}